'use strict';

export default function f() {
  return (name) => {
    return name.replace(/-/g, ' ');
  };
}



// WEBPACK FOOTER //
// ./app/src/filters/dashes_with_spaces.filter.js